/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetChangelogSubscriptionRequest
 */
export interface SetChangelogSubscriptionRequest {
    /**
     * 
     */
    subscribed: boolean;
}

/**
 * Check if a given object implements the SetChangelogSubscriptionRequest interface.
 */
export function instanceOfSetChangelogSubscriptionRequest(value: object): value is SetChangelogSubscriptionRequest {
    if (!('subscribed' in value) || value['subscribed'] === undefined) return false;
    return true;
}

export function SetChangelogSubscriptionRequestFromJSON(json: any): SetChangelogSubscriptionRequest {
    return SetChangelogSubscriptionRequestFromJSONTyped(json, false);
}

export function SetChangelogSubscriptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetChangelogSubscriptionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'subscribed': json['subscribed'],
    };
}

export function SetChangelogSubscriptionRequestToJSON(json: any): SetChangelogSubscriptionRequest {
    return SetChangelogSubscriptionRequestToJSONTyped(json, false);
}

export function SetChangelogSubscriptionRequestToJSONTyped(value?: SetChangelogSubscriptionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subscribed': value['subscribed'],
    };
}

